import apiFetch from '../apiFetch'

export default function (idEscandallo, token) {
  return apiFetch({endPoint: `Escandallo/eliminarEscandallo?idEscandallo=` + idEscandallo, method: 'GET', body: null, token: token})
}